import React from "react";
import PropTypes from "prop-types";
import { humanize } from "./userVerificationApi";

// The rules a decision matched, as chips, plus the inputs the check could not read.
function MatchedRules({ rules, inputsMissing }) {
  const missing = inputsMissing || [];
  if (!rules?.length && !missing.length) return <span className="text-muted">—</span>;

  return (
    <div>
      {(rules || []).map((rule) => (
        <span
          key={rule.id}
          className={`badge me-1 mb-1 ${rule.action === "set_under_audit" ? "bg-danger" : "bg-warning text-dark"}`}
          title={rule.note || undefined}
        >
          {rule.value}
          {rule.applies_to && rule.applies_to !== "any" ? ` (${rule.applies_to})` : ""}
        </span>
      ))}
      {missing.length > 0 && <div className="text-muted small">Missing: {missing.map(humanize).join(", ")}</div>}
    </div>
  );
}

MatchedRules.propTypes = {
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
      action: PropTypes.string,
      applies_to: PropTypes.string,
      note: PropTypes.string,
    }),
  ),
  inputsMissing: PropTypes.arrayOf(PropTypes.string),
};

export default MatchedRules;
